module.exports = __webpack_public_path__ + "static/media/CLARA.3d2ce510.svg";


//////////////////
// WEBPACK FOOTER
// ./src/CLARA.svg
// module id = 633
// module chunks = 1